export const toEmbedUrl = (url) => {
  if (!url) {
    return null
  }

  try {
    const shortId = url.match(/shorts\/([a-zA-Z0-9_-]+)/)?.[1]
    const watchId = url.match(/[?&]v=([a-zA-Z0-9_-]+)/)?.[1]
    const shareId = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/)?.[1]
    const videoId = shortId || watchId || shareId

    return videoId ? `https://www.youtube.com/embed/${videoId}` : null
  } catch {
    return null
  }
}
